export const prop = (object, path, defaultValue: any = null) => {
  const val = path.split('.').reduce((o, x) => {
    return typeof o === 'undefined' || o === null ? defaultValue : o[x];
  }, object);
  if (typeof val === 'undefined') {
    return defaultValue;
  }
  return val;
};

export function round(num, precision) {
  const factor = 10 ** precision;
  const tempNumber = num * factor;
  const roundedTempNumber = Math.round(tempNumber);
  return roundedTempNumber / factor;
}

export const text2ascii = (text: string) => {
  if (!text) {
    return '';
  }

  return text
    .replace(/[áàãâäă]/gi, 'a')
    .replace(/[čç]/gi, 'c')
    .replace(/[ď]/gi, 'd')
    .replace(/[éèêě]/gi, 'e')
    .replace(/[íìïî]/gi, 'i')
    .replace(/[ľĺ]/gi, 'l')
    .replace(/[ñň]/gi, 'n')
    .replace(/[óòöôõ]/gi, 'o')
    .replace(/[ř]/gi, 'r')
    .replace(/[šșŞş]/gi, 's')
    .replace(/[ťţ]/gi, 't')
    .replace(/[úùüûů]/gi, 'u')
    .replace(/[ý]/gi, 'y')
    .replace(/[ž]/gi, 'z')
    .replace(/[^\x20-\x7E]/g, '');
};

export function slugify(text) {
  if (!text) {
    return '';
  }

  return text2ascii(text)
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '-') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '');
}

export const removeVat = (
  price: number,
  vat: number,
  shouldRound = false,
  roundPrecision = 2,
): number => {
  const fprice = price / (1 + vat / 100);
  if (shouldRound) {
    return round(fprice, roundPrecision);
  }
  return fprice;
};

export const addVat = (
  price: number,
  vat: number,
  shouldRound = false,
  roundPrecision = 2,
): number => {
  const fprice = price * (1 + vat / 100);
  if (shouldRound) {
    return round(fprice, roundPrecision);
  }
  return fprice;
};

export const getImagePath = (
  baseUrl: string,
  filename,
  { width, height } = { width: 64, height: 80 },
  noSize = false,
  webp = false,
  typeCover = false,
) => {
  if (height === 0) {
    return `${baseUrl}${filename}&width=${width}&webp=${webp ? 1 : 0}${
      typeCover ? '&type=cover' : ''
    }`;
  }

  return noSize
    ? `${baseUrl}${filename}&webp=${webp ? 1 : 0}${
        typeCover ? '&type=cover' : ''
      }`
    : `${baseUrl}${filename}&width=${width}&height=${height}&webp=${
        webp ? 1 : 0
      }${typeCover ? '&type=cover' : ''}`;
};
